<h4>
  {{ 'LEAD_INTEGRATIONS.SETTINGS.LEAD_QUALIFICATION.DESCRIPTION' | translate }}
</h4>

<div class="option">
  <div class="option-description">
    {{
      'LEAD_INTEGRATIONS.SETTINGS.LEAD_QUALIFICATION.NO_DUPES_EXIST_DESCRIPTION'
        | translate
    }}
  </div>
  <glxy-checkbox
    [ngModel]="takeActionWhenNoDupesExist$ | async"
    (ngModelChange)="updateNoDupesChoice($event)"
  >
    <div content class="option-checkbox">
      {{
        'LEAD_INTEGRATIONS.SETTINGS.LEAD_QUALIFICATION.NO_DUPES_EXIST_ACTION'
          | translate
      }}
    </div>
  </glxy-checkbox>
</div>

<div class="option">
  <div class="option-description">
    {{
      'LEAD_INTEGRATIONS.SETTINGS.LEAD_QUALIFICATION.DUPE_EXISTS_DESCRIPTION'
        | translate
    }}
  </div>
  <glxy-checkbox
    [ngModel]="takeActionWhenDupesExist$ | async"
    (ngModelChange)="updateDupesChoice($event)"
  >
    <div content class="option-checkbox">
      {{
        'LEAD_INTEGRATIONS.SETTINGS.LEAD_QUALIFICATION.DUPE_EXISTS_ACTION'
          | translate
      }}
      <mat-icon
        class="info-icon"
        [matTooltip]="
          'LEAD_INTEGRATIONS.SETTINGS.LEAD_QUALIFICATION.DUPE_EXISTS_ACTION_TOOLTIP'
            | translate
        "
        [matTooltipPosition]="'right'"
      >
        info
      </mat-icon>
    </div>
  </glxy-checkbox>
</div>
